
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.444 11.719H17.07a.586.586 0 00.564-.425l2.343-8.203a.586.586 0 00-.563-.747H5.092L4.674.459A.586.586 0 004.102 0H.586a.586.586 0 100 1.172h3.046l2.115 9.52a1.76 1.76 0 00-1.06 1.613c0 .969.79 1.758 1.758 1.758H17.07a.586.586 0 100-1.172H6.445a.587.587 0 01-.001-1.172zm12.193-8.203l-2.009 7.03H6.915l-1.562-7.03h13.284z","fill":"#989AB3"}}),_c('path',{attrs:{"d":"M5.86 15.82c0 .97.788 1.758 1.757 1.758a1.76 1.76 0 001.758-1.758 1.76 1.76 0 00-1.758-1.758A1.76 1.76 0 005.86 15.82zm1.757-.586a.587.587 0 11-.001 1.174.587.587 0 01.001-1.174zM14.14 15.82c0 .97.79 1.758 1.758 1.758a1.76 1.76 0 001.758-1.758 1.76 1.76 0 00-1.758-1.758 1.76 1.76 0 00-1.757 1.758zm1.758-.586a.587.587 0 110 1.174.587.587 0 010-1.174z","fill":"#989AB3"}})])
          )
        }
      }
    